"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipWrapper = exports.TooltipStyled = exports.TooltipStyle = exports.LabelWrapper = exports.Label = exports.HotkeyWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tooltip = _interopRequireDefault(require("@reach/tooltip"));
var _fonts = require("../style/fonts");
var _colors = require("../style/colors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TooltipWrapper = exports.TooltipWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__TooltipWrapper",
  componentId: "bufferapp-ui__sc-11aramw-0"
})([""]);
const TooltipStyled = exports.TooltipStyled = /*#__PURE__*/(0, _styledComponents.default)(_tooltip.default).withConfig({
  displayName: "style__TooltipStyled",
  componentId: "bufferapp-ui__sc-11aramw-1"
})(["opacity:", ";"], props => props.opacity);
const TooltipStyle = exports.TooltipStyle = {
  position: 'absolute',
  background: _colors.grayDarker,
  color: _colors.white,
  border: 'none',
  borderRadius: '4px',
  padding: '8px',
  maxWidth: '200px',
  whiteSpace: 'normal',
  zIndex: 9999
};
const Label = exports.Label = /*#__PURE__*/_styledComponents.default.label.withConfig({
  displayName: "style__Label",
  componentId: "bufferapp-ui__sc-11aramw-2"
})(["color:", ";font-family:", ";font-size:", ";margin-left:", ";font-weight:", ";line-height:", ";cursor:inherit;"], props => props.color, _fonts.fontFamily, props => props.isHotkey ? '10px' : _fonts.fontSizeSmall, props => props.isHotkey ? '8px' : '0', _fonts.fontWeight, _fonts.lineHeightSmall);
const HotkeyWrapper = exports.HotkeyWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__HotkeyWrapper",
  componentId: "bufferapp-ui__sc-11aramw-3"
})(["display:flex;flex-direction:row;align-items:center;"]);
const LabelWrapper = exports.LabelWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__LabelWrapper",
  componentId: "bufferapp-ui__sc-11aramw-4"
})([""]);